import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';
import { PreloginGuard } from './core/guard/prelogin.guard';
import { LandingLayoutComponent } from './shared/landing-layout/landing-layout.component';
import { LoggedLayoutComponent } from './shared/logged-layout';
import { LoggedLayoutResolverService } from './core/services/logged-layout-resolver.service';
import { PublicationPreviewWrapperComponent } from './components/material-detail/publication-preview-wrapper/publication-preview-wrapper.component';
import { PublicLibraryResolverService } from './core/services/public-library-resolver.service';
import { LoginComponent } from './components/login/login.component';
import { JoinnowComponent } from './components/joinnow/joinnow.component';

const routes: Routes = [
  {
    path: '',
    component: LandingLayoutComponent,
    canActivate: [PreloginGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./components/landing-page/landing-page.module').then(mod => mod.LandingPageModule)
      },
      {
        path: 'search',
        loadChildren: () => import('./components/search/search.module').then(mod => mod.SearchModule)
      },
      {
        path: 'view-all',
        loadChildren: () => import('./components/view-all/view-all.module').then(mod => mod.ViewAllModule)
      },
      // {
      //   path: 'event',
      //   loadChildren: () => import('./components/event/event.module').then(mod => mod.EventModule)
      // },
      {
        path: 'material-detail/:id',
        loadChildren: () => import('./components/material-detail/material-detail.module').then(mod => mod.MaterialDetailModule)
      },
      {
        path: 'material-detail/:id/:library',
        loadChildren: () => import('./components/material-detail/material-detail.module').then(mod => mod.MaterialDetailModule)
      }
    ]
  },
  {
    path: '',
    component: LoggedLayoutComponent,
    canActivate: [AuthGuard],
    resolve: { data: LoggedLayoutResolverService },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./components/logged-landing-page/logged-landing-page.module').then(mod => mod.LoggedLandingPageModule)
      },
      {
        path: 'view-all-page',
        loadChildren: () => import('./components/view-all/view-all.module').then(mod => mod.ViewAllModule)
      },
      {
        path: '',
        loadChildren: () => import('./components/profile/profile.module').then(mod => mod.ProfileModule)
      },
      {
        path: 'search-page',
        loadChildren: () => import('./components/search/search.module').then(mod => mod.SearchModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./components/notifications/notifications.module').then(mod => mod.NotificationsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./components/settings/settings.module').then(mod => mod.SettingsModule)
      },
      {
        path: 'material-detail-page/:id',
        loadChildren: () => import('./components/material-detail/material-detail.module').then(mod => mod.MaterialDetailModule)
      },
      {
        path: 'material-detail-page/:id/:library',
        loadChildren: () => import('./components/material-detail/material-detail.module').then(mod => mod.MaterialDetailModule)
      },
      {
        path: 'private-library',
        loadChildren: () => import('./components/private-library/private-library.module').then(mod => mod.PrivateLibraryModule)
      },
      {
        path: 'collection/:slug',
        loadChildren: () => import('./components/private-library/playlist-detail/playlist-detail.module').then(mod => mod.PlaylistDetailModule)
      },
      {
        path: 'public-library',
        resolve: { addon: PublicLibraryResolverService },
        loadChildren: () => import('./components/public-library/public-library.module').then(mod => mod.PublicLibraryModule)
      },
      {
        path: 'plans-page',
        loadChildren: () => import('./components/subscription-plans/subscription-plans.module').then(mod => mod.SubscriptionPlansModule)
      },
      {
        path: 'wallet',
        loadChildren: () => import('./components/wallet/wallet.module').then(mod => mod.WalletModule)
      },
      {
        path: 'payment',
        loadChildren: () => import('./components/payment/payment.module').then(mod => mod.PaymentModule)
      },
      {
        path: 'wipod',
        loadChildren: () => import('./components/wipod/wipod.module').then(mod => mod.WipodModule)
      },
      {
        path: 'write-publication',
        loadChildren: () => import('./components/write-publication/write-publication.module').then(mod => mod.WritePublicationModule)
      },
      {
        path: 'additional-public-library-home',
        loadChildren: () => import('./components/business-modal/additional-public-library/additional-public-library-home.module').then(mod => mod.AdditionalPublicLibraryHomeModule)
      },
      {
        path: 'supplementary-account',
        loadChildren: () => import('./components/supplementary-accounts/supplementary-accounts.module').then(mod => mod.SupplementaryAccountsModule)
      },
      {
        path: 'supplementary-account/supplementary-account-detail/:id',
        loadChildren: () => import('./components/supplementary-accounts/supplementary-account-detail/supplementary-account-detail.module').then(mod => mod.SupplementaryAccountDetailModule)
      },
      {
        path: 'chats',
        loadChildren: () => import('./components/chats/chats.module').then(mod => mod.ChatsModule)
      },
      {
        path: 'analytics',
        loadChildren: () => import('./components/analytics/analytics.module').then(mod => mod.AnalyticsModule)
      },
      {
        path: 'advertisement',
        loadChildren: () => import('./components/advertisement/advertisement.module').then(mod => mod.AdvertisementModule)
      },
      {
        path: 'write-publication',
        loadChildren: () => import('./components/write-publication/write-publication.module').then(mod => mod.WritePublicationModule)
      },
      {
        path: 'manage-advertisement',
        loadChildren: () => import('./components/settings/manage-advertisement/manage-advertisement.module').then(mod => mod.ManageAdvertisementModule)
      },
      {
        path: 'collaborated-material',
        loadChildren: () => import('./components/wipod/my-collab-material/my-collab-material.module').then(mod => mod.MyCollabMaterialModule)
      },
      {
        path: 'collabration-request',
        loadChildren: () => import('./components/wipod/collabration-request/collabration-request.module').then(mod => mod.CollabrationRequestModule)
      },
      {
        path: 'public-library-content/:id',
        loadChildren: () => import('./components/business-modal/additional-public-library/public-library-content/public-library-content.module').then(mod => mod.PublicLibraryContentModule)
      },
      {
        path: 'business-subscription-plans',
        loadChildren: () => import('./components/business-modal/business-subscription-plans/business-subscription-plans.module').then(mod => mod.AdditionalPublicLibraryHomeModule)
      }
    ]
  },
  {
    path: 'preview-pdf',
    component: PublicationPreviewWrapperComponent
  },

  { path: 'the-explorer', loadChildren: () => import('./components/the-explorer/the-explorer.module').then(m => m.TheExplorerModule) },
  { path: 'the-creator', loadChildren: () => import('./components/the-creator/the-creator.module').then(m => m.TheCreatorModule) },
  { path: 'the-big-entertainer', loadChildren: () => import('./components/the-big-entertainer/the-big-entertainer.module').then(m => m.TheBigEntertainerModule) },
  { path: 'the-screener', loadChildren: () => import('./components/the-screener/the-screener.module').then(m => m.TheScreenerModule) },
  { path: 'features', loadChildren: () => import('./components/features/features.module').then(m => m.FeaturesModule) },
  { path: 'pricing', loadChildren: () => import('./components/pricing/pricing.module').then(m => m.PricingModule) },
  { path: 'faq', loadChildren: () => import('./components/faq/faq.module').then(m => m.FaqModule) },
  {
    path: 'privacy',
    loadChildren: () => import('./shared/landing-layout/landing-footer/privacy-page/privacy-page.module').then(mod => mod.PrivacyPageModule)
  },
  {
    path: 'how-it-works',
    loadChildren: () => import('./components/how-it-works/how-it-works.module').then(mod => mod.HowItWorksModule)
  },
  {
    path: 'events',
    loadChildren: () => import('./components/event/event-detail/event-detail.module').then(mod => mod.EventDetailModule)
  },
  {
    path: 'events/emse',
    loadChildren: () => import('./components/event/event-detail/event-detail.module').then(mod => mod.EventDetailModule)
  },
  {
    path: 'event-emse-2020',
    loadChildren: () => import('./components/event-emse/event-emse.module').then(mod => mod.EventEmseModule)
  },
  {
    path: 'event-emse-2021',
    loadChildren: () => import('./components/event-emse-2021/event-emse-2021.module').then(mod => mod.EventEmse2021Module)
  },
  {
    path: 'our-story',
    loadChildren: () => import('./components/our-story/our-story.module').then(mod => mod.OurStoryModule)
  },
  {
    path: 'careers',
    loadChildren: () => import('./components/careers/careers.module').then(mod => mod.CareersModule)
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./shared/landing-layout/landing-footer/contact/contact.module').then(mod => mod.ContactModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./components/forgot-password-new-ui/forgot-password-new-ui.module').then(mod => mod.ForgotPasswordNewUiModule)
  },
  {
    path: 'all-modals',
    loadChildren: () => import('./components/all-modals/all-modals.module').then(mod => mod.AllModalsModule)
  },
  {
    path: 'no-connection',
    loadChildren: () => import('./components/no-connection/no-connection.module').then(mod => mod.NoConnectionModule)
  },
  {
    path: 'website-disclaimer',
    loadChildren: () => import('./shared/landing-layout/landing-footer/website-disclaimer-page/website-disclaimer-page.module').then(mod => mod.WebsiteDisclaimerPageModule)
  },
  {
    path: 'terms-of-use',
    loadChildren: () => import('./shared/landing-layout/landing-footer/terms-of-use/terms-of-use.module').then(mod => mod.TermsOfUseModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./shared/landing-layout/landing-footer/faq/faq.module').then(mod => mod.FaqModule)
  },
  {
    path: 'plan-terms',
    loadChildren: () => import('./shared/landing-layout/landing-footer/plan-terms/plan-terms.module').then(mod => mod.PlanTermsModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./components/support/support.module').then(mod => mod.SupportModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./components/account/account.module').then(mod => mod.AccountModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./components/all-modals/all-modals.module').then(mod => mod.AllModalsModule)
  },
  { path: 'login',  canActivate: [PreloginGuard], component: LoginComponent },
  { path: 'register',canActivate: [PreloginGuard], component: JoinnowComponent },
  {path: '**',  loadChildren: () => import('./components/page-not-found/page-not-found.module').then(mod => mod.PageNotFoundModule)}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload',  scrollPositionRestoration: 'enabled', // or 'top'
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64]  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
